import { Box, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSidebarOpen } from "@/store/selectors/ui.selectors";
import Sidebar from "./Sidebar";
import Header from "./Header";

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps): JSX.Element {
  const sidebarOpen = useSelector(selectSidebarOpen);
  const theme = useTheme();
  


  return (
    <Box sx={{ display: "flex" }}>
      <Header />
      {/* Sidebar 应该放在 Header 后面，确保正确的堆叠顺序 */}
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          // 使用 MUI 推荐的方式处理固定 AppBar 的间距
          pt: `calc(64px + ${theme.spacing(4)})`, // 使用 64dp 作为基础，确保与 Sidebar 保持视觉一致性
          width: { md: `calc(100% - 240px)` },
          ml: { md: sidebarOpen ? "240px" : 0 },
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
